var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.834,
    height: 14.837,
    viewBox: "0 0 14.834 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49371",
    "data-name": "Group 49371",
    transform: "translate(-2274.383 9828.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93664",
    "data-name": "Path 93664",
    d: "M19.69,13.255a6.649,6.649,0,1,0,2.6.525A6.614,6.614,0,0,0,19.69,13.255Z",
    transform: "translate(2262.11 -9840.592)",
    fill: "none",
    stroke: "#d13438",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49369",
    "data-name": "Group 49369",
    transform: "translate(2282.507 -9840.468) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    y2: 6,
    transform: "translate(16.5 14.5) rotate(90)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    y2: 6,
    transform: "translate(13.5 11.5)",
    fill: "none",
    stroke: "#d13438",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/Rejected.e5a7687c916cfcddd26cfd64a20479a3.svg";
export { ForwardRef as ReactComponent };